var data = {
	"body": "<path d=\"M341 48q18 0 30.5 12.5T384 91v298q0 18-12.5 30.5T341 432H43q-18 0-30.5-12.5T0 389V91q0-18 12.5-30.5T43 48h89q7-19 23.5-31T192 5t36.5 12T252 48h89zm-149 0q-9 0-15 6.5t-6 15t6 15t15 6.5t15-6.5t6-15t-6-15t-15-6.5zm-43 299l171-171l-30-30l-141 140l-55-55l-30 30z\" fill=\"currentColor\"/>",
	"width": 384,
	"height": 432
};
export default data;
